import styled from 'styled-components';

export const SpinnerContainer = styled.div.attrs({
  className: 'SpinnerContainer',
})`
  all: unset;
  display: flex;
  flex-direction: column;
  padding: 5px;
  border-radius: 5px;
  background-color: #212b2fcc;
  min-height: 170px;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding-bottom: 10px;
`;
